import React, { FunctionComponent } from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';

import { updateInsertionComponentContinuouslyBearing } from '../../../../store/actions/editorActions';
import { getActiveFeaturePatternTrussSettings } from '../../../../store/selectors/activeComponentFeaturePatternSettingsSelectors';
import { getInsertingProfileTrussSettingsOrNull } from '../../../../store/selectors/profileSelectors';
import { useAppDispatch, useAppSelector } from '../../../hooks';

interface Props {
  disabled: boolean;

  value: boolean;
  onChange(value: boolean): void;
}

export const ContinuouslyBearingSettings: FunctionComponent<Props> = (props) => (
  <FormControlLabel
    control={<Checkbox checked={props.value} onChange={(event) => props.onChange(event.target.checked)} />}
    label="Continuously Bearing"
    disabled={props.disabled}
  />
);

export const ActiveComponentContinuouslyBearingSettings: FunctionComponent = () => {
  const dispatch = useAppDispatch();

  const insertingObjectInfo = useAppSelector((state) => state.application.insertingObjectInfo);

  const profileTrussSettings = useAppSelector(getInsertingProfileTrussSettingsOrNull);
  const featurePatternTrussSettings = useAppSelector(getActiveFeaturePatternTrussSettings);

  let value: boolean;
  if (profileTrussSettings) {
    value = profileTrussSettings.profile.continuouslyBearing;
  } else if (featurePatternTrussSettings) {
    value = featurePatternTrussSettings.continuouslyBearing;
  } else {
    throw new Error('Unable to find continuouslyBearing settings object.');
  }

  return (
    <ContinuouslyBearingSettings
      disabled={!insertingObjectInfo || insertingObjectInfo.type !== 'componentDesign'}
      value={value}
      onChange={(value) => dispatch(updateInsertionComponentContinuouslyBearing(value))}
    />
  );
};
